import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { LayoutStateService } from '../../../../../../app/core/services/layout-state.service';
import { AdministrationMenu, ConfigurationMenu } from '../menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class MenuComponent implements OnInit {
  menu: any[] = [];
  permissions: any[] = [];
  role: any;
  user: any;
  openedMenus: boolean[] = [];

  constructor(
    private lsService: LocalStorageService,
    public state: LayoutStateService
  ) {}

  ngOnInit(): void {
    this.user = this.lsService.get(GlobalName.userName);
    if (this.user?.roles?.length) {
      this.role = this.user.roles[0].name;
      this.permissions = this.user.roles[0]?.permissions ?? [];
    }
    this.menu = [...ConfigurationMenu, ...AdministrationMenu];
    this.openedMenus = new Array(this.menu.length).fill(false);
  }

  toggleMenu(index: number): void {
    this.openedMenus[index] = !this.openedMenus[index];
  }

  onLinkClick(): void {
    if (this.state.isMobile()) {
      this.state.closeSidebar();
    }
  }

  canShow(tags: any[]): boolean {
    if (!tags || tags.length === 0) return true;
    return tags.some(tag =>
      this.permissions.some((p: any) => p.name === `Lister ${tag}`)
    );
  }
}
